import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trim'
})
export class TrimPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    console.log(value);
    let test= value.trim();
    console.log(test);
    return test;
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/pipes/trim.pipe.ts